import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  initToken: "",
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    getApiToken: (state, action) => {
      state.initToken = action.payload;
    },
  },
});

export const { getApiToken } = configSlice.actions;

export default configSlice.reducer;
